import React from 'react';
import { Router, Switch, Route, Redirect } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { authAtom } from '_state';
import { history, useCapabilities } from '_helpers';
import { Toast } from '_ui';
import { Login } from '_components/Login';
import { ForgotPassword } from '_components/ForgotPassword';
import { ResetPassword } from '_components/ResetPassword';
import { AppShell } from '_components/AppShell';
import { defaultPath } from '_components/nav-config';
import {
    TaoHoaDon, GiaoDichCuaToi, LuongCuaToi,
    BangLuong, DoanhThu, TienMat, GiaoDich, DichVu, NhanVien,
    BanGoi, GoiDichVu,
    LopHoc, HocVien, LopCuaToi,
} from '_pages';

export { App };

// Capability gate: render children only if `allow`, else bounce to the role's landing page.
function Protected({ allow, children }) {
    const caps = useCapabilities();
    return allow ? children : <Redirect to={defaultPath(caps)} />;
}

function AuthedApp() {
    const caps = useCapabilities();
    return (
        <AppShell>
            <Switch>
                <Route path="/tao-hoa-don"><Protected allow={caps.canCreateTransaction}><TaoHoaDon /></Protected></Route>
                <Route path="/ban-goi"><Protected allow={caps.canSellPackage}><BanGoi /></Protected></Route>
                <Route path="/goi-dich-vu"><Protected allow={caps.canManagePackages}><GoiDichVu /></Protected></Route>
                <Route path="/giao-dich-cua-toi"><Protected allow={caps.canViewOwnStats}><GiaoDichCuaToi /></Protected></Route>
                <Route path="/luong-cua-toi"><Protected allow={caps.canViewOwnStats}><LuongCuaToi /></Protected></Route>
                <Route path="/bang-luong"><Protected allow={caps.canViewAllPayouts}><BangLuong /></Protected></Route>
                <Route path="/doanh-thu"><Protected allow={caps.canViewAllPayouts}><DoanhThu /></Protected></Route>
                <Route path="/tien-mat"><Protected allow={caps.canConfirmCash}><TienMat /></Protected></Route>
                <Route path="/giao-dich"><Protected allow={caps.canViewAllTransactions}><GiaoDich /></Protected></Route>
                <Route path="/dich-vu"><Protected allow={caps.canManageServices}><DichVu /></Protected></Route>
                <Route path="/nhan-vien"><Protected allow={caps.canManageEmployees}><NhanVien /></Protected></Route>
                <Route path="/lop-hoc"><Protected allow={caps.canManageClasses}><LopHoc /></Protected></Route>
                <Route path="/hoc-vien"><Protected allow={caps.canManageClasses}><HocVien /></Protected></Route>
                <Route path="/lop-cua-toi"><Protected allow={caps.canViewOwnStudy}><LopCuaToi /></Protected></Route>
                <Route path="*"><Redirect to={defaultPath(caps)} /></Route>
            </Switch>
        </AppShell>
    );
}

function App() {
    const auth = useRecoilValue(authAtom);
    const isAuthed = !!auth;

    return (
        <>
            <div className="grain-overlay" />
            <Router history={history}>
                <Switch>
                    <Route path="/login">{isAuthed ? <Redirect to="/" /> : <Login />}</Route>
                    <Route path="/account/forgot-password"><ForgotPassword /></Route>
                    <Route path="/account/resetpassword"><ResetPassword /></Route>
                    <Route path="*">{isAuthed ? <AuthedApp /> : <Redirect to="/login" />}</Route>
                </Switch>
            </Router>
            <Toast />
        </>
    );
}
